import React from "react";
import { Link, useLocation } from "react-router-dom";
import './Navbar.css';

export default function Navbar({ role }) {

    const location = useLocation();

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <nav className="bottom-bar">
            <Link
                to="/vehicles"
                className={`bottom-bar-item${isActive('/vehicles') ? ' active' : ''}`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"/>
                    <circle cx="7.5" cy="14.5" r="1.5"/>
                    <circle cx="16.5" cy="14.5" r="1.5"/>
                </svg>
                <span>Véhicules</span>
            </Link>

            {role === "ROLE_FLEET_MANAGER" && (
                <Link
                    to="/tickets"
                    className={`bottom-bar-item${isActive('/tickets') ? ' active' : ''}`}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1 0-4zm-2-1.46a4 4 0 0 0 0 6.92V18H4v-2.54a4 4 0 0 0 0-6.92V6h16v2.54z"/>
                    </svg>
                    <span>Tickets</span>
                </Link>
            )}

            <Link
                to="/profile"
                className={`bottom-bar-item${isActive('/profile') ? ' active' : ''}`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v2h20v-2c0-3.33-6.67-5-10-5z"/>
                </svg>
                <span>Profil</span>
            </Link>
        </nav>
    );
}